<template>
    <v-card flat outlined>
        <v-row class="ma-0 pa-0" align="center">
            <v-col cols="auto" class="pa-4">
                <v-avatar color="grey lighten-5">
                    <v-img :src="item?.profile?.src">
                        <template #placeholder>
                            <v-icon>mdi-account</v-icon>
                        </template>
                    </v-img>
                </v-avatar>
            </v-col>
            <v-col class="pa-4">
                <v-list-item-title class="d-flex flex-row align-center">
                    {{ item.name }}
                    <template v-if="isItemInterviewer">
                        <v-icon color="#fab617" small class="ml-4">mdi-crown</v-icon>
                    </template>
                </v-list-item-title>
                <v-list-item-subtitle>
                    {{ item.username }}
                </v-list-item-subtitle>
            </v-col>
            <v-col cols="auto" align-self="start" class="py-4 px-12">
                <v-tooltip left>
                    <template #activator="{ attrs, on }">
                        <v-icon size="x-small" v-bind="{ ...attrs, color }" v-on="on"> mdi-circle </v-icon>
                    </template>
                    {{ tooltip }}
                </v-tooltip>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
    props: {
        item: { type: Object, default: () => ({}) },
        isItemInterviewer: { type: Boolean, default: false },
    },
    computed: {
        ...mapGetters("interview/server", ["peers"]),
        ...mapState({
            isUser: function (store) {
                return store.payload?._user == this.item._id;
            },
        }),
        isActive() {
            return this.peers.some(({ _id }) => _id == this.item._id);
        },
        color() {
            if (this.isUser) return "blue lighten-1";
            if (this.isActive) return "green lighten-1";
            return "grey";
        },
        tooltip() {
            if (this.isUser) return "본인";
            if (this.isActive) return "접속중";
            return "미참여";
        },
    },
};
</script>

<style>
</style>